<template>

  <transition name="fade">
    <component :is="layout" v-if="fetched">
      <router-view/>
    </component>
    <div v-else>
      <h2 class="preloader isLoading">Trwa ładowanie</h2>
    </div>
  </transition>
</template>

<script>
export default {
    data(){
        return {
            fetched: false
        }
    },
  computed: {
    layout() {
      return `${this.$route.meta.layout || 'default'}-layout`;
    },
  },
    mounted(){
        this.$nextTick(function () {
          this.fetched = true;
          Vue.checkParams()
        })
    },
};
</script>
